var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#1677ff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4768 7C26.4564 14.4281 24.0653 17.9644 22.4973 18.8037C19.2939 21.2656 15.8115 20.3651 14.4709 19.6074C14.0093 20.6006 13.4973 22.2831 13.2991 23L11.9709 22.5977C13.4538 18.7089 16.1911 16.4194 17.3743 15.7607C20.2139 14.0122 21.2384 12.4786 21.3958 11.9307C20.5144 12.9099 18.4867 14.0414 17.5833 14.4844C15.1774 15.9672 13.8303 17.9819 13.4573 18.8037C12.2682 17.4048 12.344 15.0729 12.5305 14.082C13.174 10.711 16.295 9.72831 17.7756 9.6582C21.8465 8.8888 23.2728 7.56539 23.4768 7ZM6.93677 14.7812C7.42636 15.7884 9.69332 16.4248 10.7659 16.6172C13.3535 17.7082 12.8585 19.916 12.2874 20.8838L12.217 20.7969C11.8253 19.8456 10.4921 19.1179 9.87427 18.873C9.07712 18.6073 8.2253 17.8186 7.89868 17.457C8.20655 18.2823 9.13436 19.0484 9.55981 19.3281C10.7067 20.0555 11.3782 21.1117 11.5706 21.5488C9.43023 22.7799 7.48483 21.4899 6.77954 20.6914C5.29671 19.0967 6.26646 16.0869 6.93677 14.7812Z",
    fill: "#1677ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFresh);
export default __webpack_public_path__ + "static/media/Fresh.25d29db96ac85280d856062cef6c558e.svg";
export { ForwardRef as ReactComponent };